const ASCII_SPACE = /^[\t\n\v\f\r ]+|[\t\n\v\f\r ]+$/g;

/** Not String.trim: it also strips U+FEFF, and 93 imported accounts carry one at the start or end of their name — trimming it would delete what identifies them before the request is sent. */
export function trimLoginIdentifier(value: string): string {
  return value.replace(ASCII_SPACE, '');
}
